import { Component } from '@theme/component';

class TekkaoChatInvite extends Component {
  #timer;
  #observer;
  #abort;
  #elapsed = 0;
  #last = 0;
  #key = 'tekkao-chat-invite-v1';
  #chat;
  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    const signal = this.#abort.signal;
    this.hidden = true;
    try { if (sessionStorage.getItem(this.#key)) return; } catch { return; }
    this.querySelector('[data-dismiss]')?.addEventListener('click', () => this.#dismiss(), { signal });
    this.querySelector('[data-open]')?.addEventListener('click', () => {
      if (!this.#chat?.isConnected) return;
      this.#chat.setAttribute('mode', 'standalone');
      this.#chat.setAttribute('open', '');
      this.#dismiss();
    }, { signal });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !event.isComposing && !this.hidden) this.#dismiss();
    }, { signal });
    document.addEventListener('visibilitychange', () => {
      this.#last = performance.now();
    }, { signal });
    customElements.whenDefined('shopify-chat').then(() => {
      if (signal.aborted || !this.isConnected) return;
      this.#chat = document.querySelector('#chat-drawer shopify-chat');
      if (!this.#chat) return;
      this.#observer?.disconnect();
      this.#observer = new MutationObserver(() => {
        if (this.#chat.hasAttribute('open')) this.#dismiss();
      });
      this.#observer.observe(this.#chat, { attributes: true, attributeFilter: ['open'] });
      if (this.#chat.hasAttribute('open')) { this.#dismiss(); return; }
      this.#last = performance.now();
      clearInterval(this.#timer);
      this.#timer = setInterval(() => this.#tick(), 500);
    });
  }
  #tick() {
    const now = performance.now();
    const delta = Math.min(now - this.#last, 1000);
    this.#last = now;
    if (document.visibilityState !== 'visible') return;
    if (!this.#chat?.isConnected) { this.#dismiss(); return; }
    if (this.#chat.hasAttribute('open')) { this.#dismiss(); return; }
    this.#elapsed += delta;
    if (this.#elapsed < 25000 || document.querySelector('dialog[open]')) return;
    try {
      if (sessionStorage.getItem(this.#key)) { this.#dismiss(); return; }
      sessionStorage.setItem(this.#key, '1');
    } catch { this.#dismiss(); return; }
    this.hidden = false;
    clearInterval(this.#timer);
  }
  #dismiss() {
    this.hidden = true;
    clearInterval(this.#timer);
    try { sessionStorage.setItem(this.#key, '1'); } catch {}
    this.#observer?.disconnect();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.#timer);
    this.#observer?.disconnect();
    this.#abort?.abort();
  }
}
if (!customElements.get('tekkao-chat-invite')) customElements.define('tekkao-chat-invite', TekkaoChatInvite);
